import { render, staticRenderFns } from "./NewAssetLibrary.vue?vue&type=template&id=0dec8703&scoped=true&"
import script from "./NewAssetLibrary.vue?vue&type=script&lang=js&"
export * from "./NewAssetLibrary.vue?vue&type=script&lang=js&"
import style0 from "./NewAssetLibrary.vue?vue&type=style&index=0&id=0dec8703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec8703",
  null
  
)

export default component.exports